import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b462aacc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "g-modal-body" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "swiper-container swiper-guide-container animation-image" }
const _hoisted_4 = { class: "swiper-wrapper" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination swiper-guide-pagination" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, " 存为默认地址，以后无需再填 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 使用教程 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["g-modal tutorial", _ctx.visible? 'visible': 'unvisible'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tutorialImages, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "swiper-slide",
                key: index
              }, [
                _createElementVNode("img", {
                  src: item,
                  class: "banner-img"
                }, null, 8, _hoisted_5)
              ]))
            }), 128))
          ]),
          _hoisted_6
        ]),
        _hoisted_7,
        _hoisted_8
      ]),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeTutorialModal && _ctx.closeTutorialModal(...args))),
        class: "footer"
      }, " 我知道了 ")
    ])
  ], 2))
}